export default __webpack_public_path__ + "static/6601-69e885325216197e091240d7a85acbcd.jpg";